export enum FontSize {
  SMALL = '12px',
  NORMAL = '16px',
  LARGE = '20px',
}
